export const originalType = 'originals'
export const analogType = 'analogs'
export const sphinxType = 'sphinx'
export const linemediaOriginalType = 'analog_type_N'
export const linemediaAnalogType = 'analog_type_0'
export const linemediaSphinxType = 'analog_type_SPHINX'

const partGroupes = [
    {
        type: originalType,
        linemedia_group: linemediaOriginalType,
        show_no_parts_msg: true,
        lang: {
            table: {
                title: 'Искомый артикул',
                no_parts: 'Запрошенного артикула не найдено'
            }
        }
    },
    {
        type: analogType,
        linemedia_group: linemediaAnalogType,
        title: analogType,
        show_no_parts_msg: true,
        lang: {
            table: {
                title: 'Аналоги',
                no_parts: 'Аналоги не найдены'
            }
        }
    },
    {
        type: sphinxType,
        linemedia_group: linemediaSphinxType,
        title: sphinxType,
        show_no_parts_msg: false,
        lang: {
            table: {
                title: 'Товары с похожим артикулом или названием',
                no_parts: ''
            }
        }
    }
]

export default partGroupes
